import { render, staticRenderFns } from "./ModalUploadSDK.vue?vue&type=template&id=35d9467c&scoped=true"
import script from "./ModalUploadSDK.vue?vue&type=script&lang=js"
export * from "./ModalUploadSDK.vue?vue&type=script&lang=js"
import style0 from "./ModalUploadSDK.vue?vue&type=style&index=0&id=35d9467c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9467c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d9467c')) {
      api.createRecord('35d9467c', component.options)
    } else {
      api.reload('35d9467c', component.options)
    }
    module.hot.accept("./ModalUploadSDK.vue?vue&type=template&id=35d9467c&scoped=true", function () {
      api.rerender('35d9467c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalUploadSDK.vue"
export default component.exports